module.exports = __webpack_public_path__ + "assets/img/22_276_big.f73b0988.jpg";